<script lang="ts">
    import {KpPopoverPanel} from 'shared/ui-widgets/popover';
    import {Menu, MenuButton, MenuItems} from '@rgossiaux/svelte-headlessui';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {floatingUiCommonSettings} from 'shared/utils/floating-ui-common-settings';
    import {uuid as generateUuid} from 'shared/utils/custom-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let isDisabled = false;
    export let additionalButtonClasses = '';
    export let additionalContainerClasses = '';
    export let additionalMenuClasses = '';
    export let arrowHidden = false;
    export let id: string | null = generateUuid();

    const [floatingRef, floatingContent] = createFloatingActions(floatingUiCommonSettings('bottom-end'));

    $: buttonId = `${id}-dropdown-menu-wrapper-button`;
    $: panelId = `${id}-dropdown-menu-wrapper-panel`;
</script>

<Menu as="div"
      class="kp-dropdown-wrapper {additionalContainerClasses}"
      use={[floatingRef]}
      let:open>

    <MenuButton id={buttonId}
                disabled={isDisabled}
                class="dropdown-wrapper-button dropdown-toggle {additionalButtonClasses}">

        <slot name="button"/>

        {#if !arrowHidden}
            <span class="icon-container" class:opened={open}>
                <UIcon icon="angle-small-down" additionalClasses="dropdown-angle-arrow"/>
            </span>
        {/if}
    </MenuButton>

    <KpPopoverPanel {open}
                    id={panelId}
                    popoverMode="manual"
                    use={[floatingContent]}>

        <MenuItems as="ul"
                   class="dropdown-menu-items {additionalMenuClasses}"
                   static>

            <slot name="menu"/>
        </MenuItems>
    </KpPopoverPanel>
</Menu>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    :global {
        .kp-dropdown-wrapper {
            display: flex;
            flex-direction: column;
            white-space: normal;

            .dropdown-wrapper-button {
                display: inline-flex;
                align-items: center;
                cursor: pointer;
                border: none;
                background: none;
                padding: 0;
                gap: @spacing-s;

                .icon-container {
                    display: flex;
                    font-size: @font-size-small;
                    transition: rotate 0.2s ease-in-out;

                    &.opened {
                        rotate: -180deg;
                    }
                }
            }

            .kp-popover-panel {
                --popover-content-padding: @spacing-s;
            }

            .dropdown-menu-items {
                display: flex;
                flex-direction: column;
                min-width: 200px;
                max-height: 400px;
                overflow-y: auto;
            }
        }
    }
</style>